<div class="main-page-section default_font p-3 p-md-4 px-lg-5">
    <div class="breadcrumbs-section p-0 mb-3 mb-md-4 mb-lg-5">
        <span class="prev-page pr-1 prev"><a routerLink="/overview">Home</a></span>
        <span class="separator">&nbsp; &nbsp;</span>
        <img src="../../assets/images/seperator.png">
        <span class="separator">&nbsp; &nbsp;</span>
        <span class="prev-page pr-1 prev"><a routerLink="/create-survey">Create New Survey</a></span>
        <span class="separator">&nbsp; &nbsp;</span>
        <img src="../../assets/images/seperator.png">
        <span class="separator">&nbsp; &nbsp;</span>
        <span class="curr-page pl-1 breadcrumbs-section-font">List Polls / Survey</span>
        <!-- <span class="separator">&nbsp; > &nbsp;</span>
        <span class="curr-page pl-1 breadcrumbs-section-font">Plant Details</span> -->
    </div>
    <div class="d-flex align-items-center justify-content-between mb-3 mb-md-4">
        <h2 class="font-weight-medium mb-3 mb-md-4">Previous Surveys / Polls</h2>
    </div>

    <div class="filter_bar border-top border-bottom border-light mb-4 mb-md-5 mx-n5 px-5">
        <div class="row">
            <div class="col-12 col-md-6 col-lg-2 py-2 py-md-3 border-right border-light d-flex align-items-center">
                <svg-icon src="./assets/images/icons/calendar_cyan.svg" class="field_icon"></svg-icon>
                <div class="form-group floating_form_field mb-0 w-100">
                    <input class="form-control border-0 datepicker_field" (click)="d1.toggle()" [(ngModel)]="fDate"
                        ngbDatepicker #d1="ngbDatepicker" (dateSelect)="updateSelectedDate($event)">
                    <label>From</label>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-2 py-2 py-md-3 border-right border-light d-flex align-items-center">
                <svg-icon src="./assets/images/icons/calendar_cyan.svg" class="field_icon"></svg-icon>
                <div class="form-group floating_form_field mb-0 w-100">
                    <input class="form-control border-0 datepicker_field" [minDate]="fDate" (click)="d2.toggle()"
                        [(ngModel)]="tDate" ngbDatepicker #d2="ngbDatepicker"
                        (dateSelect)="updateSelectedToDate($event)">
                    <label>To</label>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-3 py-2 py-md-3 border-right border-light d-flex align-items-center">
                <svg-icon src="./assets/images/icons/sort_cyan.svg" class="field_icon"></svg-icon>
                <div [autoClose]="'outside'" [ngbPopover]="popContentSort" triggers="manual" #q="ngbPopover"
                    (click)="openPopoverSort(q)" (clickOutside)="onClickedOutside($event)" placement="bottom"
                    popoverClass="search_select_popover" class='py-0 px-0 w-100 pl-3'>
                    <span class="_popover_label">Sort by</span>
                    <span class="d-flex justify-content-end _popover_arrow">
                        <img src="/assets/images/Path.png" class="padding-left-image pr-3 justify-content-between" />
                    </span>
                    <div class="all">{{selectedSurveySortName}}</div>
                    <ng-template #popContentSort>
                        <div class="popover_search">
                            <svg-icon src="/assets/images/icons/search.svg"></svg-icon>
                            <input type="text" placeholder='Search' [(ngModel)]="searchGroupSort" />
                        </div>
                        <div class="popover_content">
                            <div class="popover_items">
                                <div class="popover_item d-flex align-items-center justify-content-between"
                                *ngFor="let groupsort of getFilteredSurveyLatestTypes();let i=index"
                                    [ngClass]="multiSelectGroupSort == groupsort?.surveyTypeNameSort && 'active'"
                                    (click)="sort('surveyStartDate',newmainSurveyList); selectSurveyTypeSort(groupsort);">
                                    {{groupsort?.surveyTypeNameSort}}
                                    <svg-icon src="/assets/images/icons/tick.svg"
                                        *ngIf="multiSelectGroupSort == groupsort?.surveyTypeNameSort"></svg-icon>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-5 py-2 py-md-3 d-flex align-items-center">
                <form class="search_form w-100">
                    <svg-icon src="./assets/images/icons/search.svg"></svg-icon>
                    <input type="text" name="searchText" id="menu-search" class="search_field"
                        placeholder="Type here to search…" [(ngModel)]="searchText" (keyup)="searchByText(searchText)"
                        (search)="searchByText(searchText)">
                    <button type="submit" class="d-none"></button>
                </form>
            </div>
        </div>
    </div>

    <div class="mb-4 mb-md-5 d-flex align-items-center justify-content-between">
        <h3 class="h6 font-weight-bold text-dark">{{totalRows}} Survey{{totalRows > 1 ? 's' : null}}</h3>
        <div class="d-flex align align-items-center column-gap-2" *ngIf="surveyRemove">
            <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" [(ngModel)]="masterSelectedSurvey" name="list_name"
                    value="m1" (change)="checkUncheckAll()" id="all_list_name">
                <label class="custom-control-label cursor-pointer" for="all_list_name">Select all</label>
            </div>
            <div ngbDropdown *ngIf="showDropdown">
                <button type="button" class="dropdown_dots px-2 text-primary" id="download_dropdown" ngbDropdownToggle>
                    <svg-icon src="../../../assets/images/icons/more_dots.svg"
                        [svgStyle]="{ 'height.px':20 }"></svg-icon>
                </button>
                <div ngbDropdownMenu aria-labelledby="download_dropdown">
                    <button ngbDropdownItem (click)="openModalRemoveSurvey(onlySurveyIds)">Remove Selected</button>
                </div>
            </div>
        </div>
    </div>

    <div class="row row-gap-4">
        <div class="col-12 col-md-6 col-lg-4 col-xl-3" *ngFor="let survey of newmainSurveyList | paginate: { itemsPerPage: 12,
            currentPage: page, totalItems:newmainSurveyList?.length }; let i=index">
            <div class="bg-lighter p-3 rounded d-flex align-items-center column-gap-2 h-100">
                <div class="custom-control custom-checkbox flex-shrink-0 mt-1" *ngIf="surveyRemove">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="survey.isSelected" name="list_name"
                        [id]="survey.surveyId + 'list_name'" value="{{survey.surveyId}}" (change)="isAllSelected()">
                    <label [for]="survey.surveyId + 'list_name'" class="custom-control-label cursor-pointer"></label>
                </div>
                <div>
                    <h3 class="font-weight-bold text-primary h5 mb-1 mb-md-2 cursor-pointer"
                        (click)="goToSurveyDetails(survey.surveyId, survey.surveyName)">
                        {{survey.surveyName}}</h3>
                    <p class="small mb-1">Start Date: {{formatDateAll(survey?.surveyStartDate,'date')}}</p>
                    <p class="small mb-0">End Date: {{formatDateAll(survey?.surveyEndDate,'date')}}</p>
                </div>
            </div>
        </div>
    </div>

    <div class="d-flex justify-content-center pagination-section mt-4" *ngIf="mainSurveyList?.length > 12">
        <div class="custom_pagination mt-4 mt-md-5 small">
            <div class="border border-light">
                <pagination-controls class="pagination" (pageChange)="handelSurveyList($event)"
                    class="d-flex justify-content-center">
                </pagination-controls>
                <div class="page_numbers">
                    {{indexPage}}/{{paginationCount(mainSurveyList?.length)}}</div>
                <!-- <div class="page_numbers">
                    {{paginationCount(mainSurveyList?.length)}}/{{indexPage}}</div> -->
            </div>
        </div>
    </div>
</div>